import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed, toRefs, } from 'vue';
import { hubListHeader } from '@/constants/operationSetting/headers';
import { targetType } from '@/constants/operationSetting/option';
import { i18n } from '@/locales';
import { operationSettingActionType } from '@/vuex-store/operation-setting/actions';
import { operationSettingGetterType } from '@/vuex-store/operation-setting/getters';
import vuexStore from '@/vuex-store';
import SearchInput from '@/components/Form/SearchInput.vue';
import ListTemplate from './ListTemplate.vue';
const lc = 'views.operation_setting.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'HubList',
    props: {
        isFetching: { type: Boolean, default: true },
        isError: { type: Boolean, default: false }
    },
    setup(__props) {
        const locales = {
            hubList: i18n.t(`${lc}hub_list`),
            changeHubSetting: i18n.t(`${lc}change_hub_setting`),
            hubSearchPlaceholder: i18n.t(`${lc}hub_search_placeholder`),
        };
        const props = __props;
        const { isFetching, isError } = toRefs(props);
        const hubList = computed(() => vuexStore.getters[operationSettingGetterType.getterFilteredHubList]);
        const checkedList = computed(() => vuexStore.getters[operationSettingGetterType.getterHubCheckedList]);
        const isSettingDialogButtonDisabled = computed(() => checkedList.value.length === 0);
        const handleSearch = (word) => {
            vuexStore.dispatch(operationSettingActionType.updateSearchQuery, {
                target: targetType.HUB,
                word,
            });
        };
        /**
             * 설정 다이얼로그 클릭 이벤트 핸들러
             */
        const handleClickSettingDialogBtn = () => {
            vuexStore.dispatch(operationSettingActionType.setIsOpenDialog, true);
            vuexStore.dispatch(operationSettingActionType.selectedTarget, targetType.HUB);
        };
        /**
             * 채크박스 클릭 이벤트
             * 한개만 추출
             */
        const handleClickCheckBox = (_item) => {
            vuexStore.dispatch(operationSettingActionType.updateCheckBox, {
                target: targetType.HUB,
                selected: _item,
            });
        };
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            return (_openBlock(), _createBlock(ListTemplate, {
                target: _unref(targetType).HUB,
                title: locales.hubList,
                headers: _unref(hubListHeader),
                list: hubList.value,
                "is-fetching": _unref(isFetching),
                "is-error": _unref(isError),
                "checked-list": checkedList.value,
                onHandleClickCheckBox: handleClickCheckBox
            }, {
                controller: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                        class: "brg-btn info outlined size-l",
                        disabled: isSettingDialogButtonDisabled.value,
                        onClick: handleClickSettingDialogBtn
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(locales.changeHubSetting), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["disabled"]),
                    _createVNode(SearchInput, {
                        class: "search-text-field",
                        width: 260,
                        placeholder: locales.hubSearchPlaceholder,
                        "on-search": handleSearch
                    }, null, 8 /* PROPS */, ["placeholder"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["target", "title", "headers", "list", "is-fetching", "is-error", "checked-list"]));
        };
    }
});
